import React, { FC } from 'react';
import { useUser } from 'store/User/Context';
import styled from 'styled-components';

import Modal from 'components/common/Modal/Modal';

import LendiWidget from './LendiWidget';

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1300px;
    height: 90vh;
    margin: 0 auto;
    padding: 10px;

    @media (max-width: 991px) {
        overflow-y: auto;
    }
`;

const WidgetsRow = styled.div`
    display: flex;
    gap: 30px;
    width: 100%;
    flex: 1;

    @media (max-width: 991px) {
        flex-direction: column;
        flex: none;
    }
`;

const WidgetSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
        text-align: center;
        margin: 0 0 15px 0;
        font-size: 18px;
        color: var(--color-primary);
    }

    @media (max-width: 991px) {
        min-height: 700px;
    }
`;

const Divider = styled.div`
    width: 1px;
    background: var(--color-border);
    align-self: stretch;

    @media (max-width: 991px) {
        display: none;
    }
`;

export interface LendiWidgetModalProps {
    isOpen: boolean;
    onClose: (e: React.MouseEvent | KeyboardEvent) => void;
}

const LendiWidgetModal: FC<LendiWidgetModalProps> = ({
    isOpen,
    onClose
}) => {
    const { user } = useUser();

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            centeredContent
            backgroundColor={user.isDarkMode ? 'var(--color-alt-second)' : '#fff'}
        >
            <ModalContent onClick={(e: React.MouseEvent) => e.stopPropagation()}>
                <WidgetsRow>
                    <WidgetSection>
                        <h2>Oblicz ratę kredytu</h2>
                        {isOpen && <LendiWidget widgetName="BaseInstallmentPicker"/>}
                    </WidgetSection>
                    <Divider />
                    <WidgetSection>
                        <h2>Umów spotkanie z doradcą</h2>
                        {isOpen && <LendiWidget widgetName="MeetingPlannerWidget" />}
                    </WidgetSection>
                </WidgetsRow>
            </ModalContent>
        </Modal>
    );
};

export default LendiWidgetModal;
